<ul *ngIf="labels?.length > 0" class="labels">
  <li *ngFor="let label of labels" (click)="onLabelSelected(label.name)" [ngClass]="{'selected': label.name == labelSelected}">
    <fa-icon icon="tag" [style.color]="label.color || 'inherit'"></fa-icon>
    <fa-icon *ngIf="label.name == labelSelected" icon="times" class="close" (click)="onLabelUnselected($event)"></fa-icon>
    <div>
      {{label.name}}
    </div>
  </li>
</ul>
